module.exports = __webpack_public_path__ + "static/media/arrow-right.5b5fa8e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right.svg
// module id = 269
// module chunks = 0